import React from "react";

export const PageHeader = ({ overline, title, subtitle, bgImage }) => {
  return (
    <section
      className="relative pt-32 pb-16 md:pt-40 md:pb-20 bg-brand-blue overflow-hidden"
      data-testid="page-header"
    >
      {bgImage && (
        <div className="absolute inset-0">
          <img src={bgImage} alt="" className="w-full h-full object-cover opacity-25" />
          <div className="absolute inset-0 bg-gradient-to-r from-brand-blue via-brand-blue/90 to-brand-blue/60" />
        </div>
      )}
      <div className="absolute inset-0 blueprint-grid opacity-30" />
      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
        <p className="overline text-brand-orange">{overline}</p>
        <h1 className="font-heading font-black tracking-tight text-white text-4xl md:text-5xl lg:text-6xl mt-4 max-w-4xl">
          {title}
        </h1>
        {subtitle && (
          <p className="text-white/75 text-lg mt-5 max-w-2xl leading-relaxed">{subtitle}</p>
        )}
      </div>
    </section>
  );
};
